import React, { useEffect } from "react";
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import _, { set } from "lodash";
import Moment from "react-moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { getAgenciesPartners, loadAgencies } from "../../../store/partner";
import { getAllMonths, getAllYears } from "../../../../services/appService";
import { getMonthlyBurnHourCandidates, getQuartlyBurnHourCandidates, loadMonthlyBurnHourCandidates, loadQuartlyBurnHourCandidates } from "../../../store/reports";
import GeneratePdf from "../../../../components/GeneratePdf";

const BurnHourCandidate = () => {

    const years = getAllYears();
    const months = getAllMonths();

    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");

    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [rptShowHide, setRptShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);

    const [selectedAgency, setSelectedAgency] = useState("");
    const [selectedCandidate, setSelectedCandidate] = useState("");
    const [rptType, setRptType] = useState("");
    const [agencies, setAgencies] = useState([]);
    const [candidates, setCandidates] = useState([]);
    const [allAgenciesCandidates, setAllAgenciesCandidates] = useState([]);
    const [allCandidateBurnRpt, setAllCandidateBurnRpt] = useState([]);
    const [candidatesBurnRpt, setCandidatesBurnRpt] = useState([]);

    const agenciesPartnersSelector = useSelector(getAgenciesPartners);
    const monthlyBurnHourCandidatesSelector = useSelector(getMonthlyBurnHourCandidates);
    const quartlyBurnHourCandidatesSelector = useSelector(getQuartlyBurnHourCandidates);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadAgencies())
        //dispatch(loadMonthlyBurnHourCandidates())
    }, []);

    useEffect(() => {
        if (agenciesPartnersSelector.length > 0) {
            setAllAgenciesCandidates(agenciesPartnersSelector);
            const list = _.unionBy(agenciesPartnersSelector, "title");
            setAgencies(list);
        }
    }, [agenciesPartnersSelector]);


    useEffect(() => {
        //setAllCandidateBurnRpt(monthlyBurnHourCandidatesSelector);
        let filterData = monthlyBurnHourCandidatesSelector;
        if (selectedAgency !== "")
            filterData = filterData.filter((x) => x.agencyName === selectedAgency);
        if (selectedCandidate !== "")
            filterData = filterData.filter(
                (x) => x.id === parseInt(selectedCandidate)
            );
        if (year !== "")
            filterData = filterData.filter((x) => x.year === parseInt(year));
        if (month !== "")
            filterData = filterData.filter((x) => x.month === parseInt(month));

        setCandidatesBurnRpt(filterData);
    }, [monthlyBurnHourCandidatesSelector])

    useEffect(() => {
        //setAllCandidateBurnRpt(quartlyBurnHourCandidatesSelector);
        let filterData = quartlyBurnHourCandidatesSelector;
        if (selectedAgency !== "")
            filterData = filterData.filter((x) => x.agencyName === selectedAgency);
        if (selectedCandidate !== "")
            filterData = filterData.filter(
                (x) => x.id === parseInt(selectedCandidate)
            );
        if (year !== "")
            filterData = filterData.filter((x) => x.year === parseInt(year));
        if (month !== "")
            filterData = filterData.filter((x) => x.month === parseInt(month));

        setCandidatesBurnRpt(filterData);
    }, [quartlyBurnHourCandidatesSelector])

    const handleAgencyChange = ({ currentTarget }) => {
        const agencyCandidates = allAgenciesCandidates.filter(
            (x) => x.title === currentTarget.value
        );
        setCandidates(agencyCandidates);
        setSelectedAgency(currentTarget.value);

        let filterData = [];
        if (rptType === "m")
            filterData = monthlyBurnHourCandidatesSelector;
        else if (rptType === "q")
            filterData = quartlyBurnHourCandidatesSelector;


        if (currentTarget.value !== "")
            filterData = filterData.filter((x) => x.agencyName === currentTarget.value);

        setCandidatesBurnRpt(filterData);
    };

    const handleMonthlyBurnRpt = () => {
        if (rptType === "q")
            dispatch(loadQuartlyBurnHourCandidates());
        else if (rptType === "m")
            dispatch(loadMonthlyBurnHourCandidates());
    };

    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const generateBurnHrCandidatePdf = () => {
        const headers = [
            [
                "ID",
                "Name",
                "Client",
                "Fixed Hrs",
                "Year",
                "Month",
                "Hrs Worked",
                "Balance Hrs",
            ],
        ];

        const colData = [];
        candidatesBurnRpt.map((item) => {
            const dt = [];
            dt.push(
                item.id,
                item.name,
                item.agencyName,
                item.fixedHrs,
                item.year
            );
            dt.push(months.filter((x) => x.id === item.month)[0]?.name);
            dt.push(item.workedHrs)
            dt.push(item.balanceHrs)
            colData.push(dt);
        });


        setSelectedCol(headers);
        setSelectedColData(colData);
        setPdfShowHide(true);
    }

    const handleRptTypeChange = ({ currentTarget }) => {
        setRptType(currentTarget.value);
        setCandidatesBurnRpt([]);
    }

    const handleSelectedCandidateChange = ({ currentTarget }) => {
        setSelectedCandidate(currentTarget.value);
        let filterData = [];
        if (rptType === "m")
            filterData = monthlyBurnHourCandidatesSelector;
        else if (rptType === "q")
            filterData = quartlyBurnHourCandidatesSelector;

        if (currentTarget.value !== "")
            filterData = filterData.filter(
                (x) => x.id === parseInt(currentTarget.value)
            );
        setCandidatesBurnRpt(filterData);
    }

    const handleChangeYear = ({ currentTarget }) => {
        setYear(currentTarget.value);
        let filterData = [];
        if (rptType === "m")
            filterData = monthlyBurnHourCandidatesSelector;
        else if (rptType === "q")
            filterData = quartlyBurnHourCandidatesSelector;
        if (currentTarget.value !== "")
            filterData = filterData.filter((x) => x.year === parseInt(currentTarget.value));
        setCandidatesBurnRpt(filterData);
    }

    return <>
        <div className="card shadow-none border">
            <div className="card-header text-center p-3 bg-lighter">
                <h4 className="mb-0">
                    Burn Reports - Per Candidate Basis
                </h4>
            </div>
            <div className="card-body p-3">
                <div className="row">
                    <div className="col-md-2">
                        <select
                            name="rptType"
                            id="rptType"
                            className="form-control form-control-sm"
                            onChange={handleRptTypeChange}
                            value={rptType}
                        >
                            <option value="">Select Type</option>
                            <option value="m">Monthly</option>
                            <option value="q">Quarterly</option>

                        </select>
                    </div>
                    <div className="col-md-2">
                        <select
                            name="agencyName"
                            id="agencyName"
                            className="form-control form-control-sm"
                            onChange={handleAgencyChange}
                            value={selectedAgency}
                        >
                            <option value="">Select Client</option>
                            {agencies.map((item) => (
                                <option value={item.title}>
                                    {item.title}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <select
                            name="candidateId"
                            id="candidateId"
                            className="form-control form-control-sm"
                            onChange={handleSelectedCandidateChange}
                            value={selectedCandidate}
                        >
                            <option value="">Select</option>
                            {candidates.map((item) => (
                                <option value={item.performerid}>
                                    {item.performername} {item.lastName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-1">
                        <select
                            name="year"
                            id="year"
                            className="form-control form-control-sm"
                            onChange={handleChangeYear}
                            value={year}
                        >
                            <option value="">Year</option>
                            {years.map((y) => (
                                <option value={y.name}>
                                    {y.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-sm btn-outline-default"
                            disabled={rptType === ""}
                            onClick={handleMonthlyBurnRpt}
                        >
                            Generate
                        </button>
                    </div>
                    <div className="col-md-3 text-right">
                        <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-sm btn-outline-default"
                            table="burnTable"
                            filename="Monthly_Burn_Report"
                            sheet="Monthly_Burn_Report"
                            buttonText="Export to Excel"
                        />
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-default"
                            onClick={generateBurnHrCandidatePdf}
                        >
                            Generate PDF
                        </button>
                    </div>

                    <div className="col-md-12 mt-2">
                        <div className="table-responsive">
                            <table
                                className="table align-items-center table-flush table-hover table-striped mb-2 border"
                                id="burnTable"
                            >
                                <thead className="thead-light">
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Client</th>
                                    <th>Fixed Hrs</th>
                                    <th>Year</th>
                                    <th>
                                        {rptType === "q" && "Quarter"}
                                        {rptType === "m" && "Month"}
                                    </th>
                                    <th>Hrs Worked</th>
                                    <th>Balance Hrs</th>
                                </thead>
                                <tbody>
                                    {candidatesBurnRpt.map(
                                        (item, key) => (
                                            <tr>
                                                <td>
                                                    {key > 0 &&
                                                        item.id ===
                                                        candidatesBurnRpt[key - 1]
                                                            .id
                                                        ? ""
                                                        : item.id}
                                                </td>
                                                <td>
                                                    {key > 0 &&
                                                        item.name ===
                                                        candidatesBurnRpt[key - 1]
                                                            .name
                                                        ? ""
                                                        : item.name}
                                                </td>
                                                <td>
                                                    {key > 0 &&
                                                        item.agencyName ===
                                                        candidatesBurnRpt[key - 1]
                                                            .agencyName
                                                        ? ""
                                                        : item.agencyName}
                                                </td>
                                                <td>{item.fixedHrs}h</td>
                                                <td>{item.year}</td>
                                                <td>
                                                    {rptType === "m" && months.filter((x) => x.id === item.month)[0]?.name}
                                                    {rptType === "q" && `Quarter ${item.quarterNumber}`}
                                                </td>

                                                <td>{item.workedHrs}h {item.workedMins}m</td>
                                                <td>{item.balanceHrs}h {item.balanceMins}m</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <GeneratePdf
            handlepdfShowHide={handlepdfShowHide}
            pdfShowHide={pdfShowHide}
            selectedCol={selectedCol}
            selectedColData={selectedColData}
        ></GeneratePdf>
    </>
}

export default BurnHourCandidate;